/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TunnelClientCount = {
  family: string;
  requests: number;
};

/** @internal */
export const TunnelClientCount$inboundSchema: z.ZodMiniType<
  TunnelClientCount,
  unknown
> = z.object({
  family: z.string(),
  requests: z.int(),
});

export function tunnelClientCountFromJSON(
  jsonString: string,
): SafeParseResult<TunnelClientCount, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunnelClientCount$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunnelClientCount' from JSON`,
  );
}
